<template>
  <v-skeleton-loader
    :width="width"
    :height="height"
    type="image"
    v-if="isLoading"
  />
  <img
    v-else-if="!zoomable && imgSrc"
    alt="image_media"
    class="image-media__img"
    :data-testid="testId"
    :src="imgSrc"
    :width="width"
    :height="height"
    @load="$emit('loaded')"
  />
  <div
    v-else-if="!imgSrc"
    class="image-media__empty-state d-flex align-center justify-center"
    :style="{ height: height, width: width }"
  >
    <v-icon color="blue-grey" size="32">
      mdi-image-outline
    </v-icon>
  </div>
  <ImageZoom
    v-else-if="!isLoading && zoomable"
    class="zoomer"
    img-class="image-zoomer"
    :click-zoom="true"
    :data-testid="testId"
    :regular="imgSrc"
    :show-message="false"
  />
</template>

<script>
import _ from 'lodash'
import ImageZoom from 'vue-image-zoomer'

import MediaSDK from '@/lib/ReverMediaSDK'

export default {
  components: {
    ImageZoom,
  },

  props: {
    src: {
      required: false,
      type: [Object, String],
    },
    defaultImage: {
      required: false,
    },
    testId: {
      required: false,
      type: String,
      default: 'image-media',
    },
    size: {
      required: false,
      type: String,
    },
    zoomable: {
      required: false,
      type: Boolean,
      default: false,
    },
    width: {
      required: false,
      type: [String, Number],
      default: 'auto',
    },
    height: {
      required: false,
      type: [String, Number],
      default: 'auto',
    },
  },

  data() {
    return {
      isLoading: false,
      fetchedImgSrc: null,
    }
  },

  computed: {
    imgSrc() {
      if (!this.fetchedImgSrc && this.defaultImage) return this.defaultImage
      if (!this.defaultImage && !this.fetchedImgSrc) return null
      if (_.isString(this.fetchedImgSrc)) return this.fetchedImgSrc
      return null
    },
  },

  created() {
    this.getPhoto()
  },

  watch: {
    src() {
      this.fetchedImgSrc = null
      this.getPhoto()
    },
  },

  methods: {
    async getPhoto() {
      if (_.isEmpty(this.src)) return

      try {
        this.isLoading = true
        this.fetchedImgSrc = await MediaSDK.getImageSrc(this.src, this.size)
      } catch (error) {
        this.$emit('error', error)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.image-media {
  overflow: hidden;

  &__img {
    object-fit: cover;
  }

  &__widget-loader {
    max-height: 33%;
    max-width: 33%;
  }
  &__empty-state {
    background-color: $color-blue-grey-lighten3;
    transition: background-color 0.2s ease;
  }
}
</style>
